import { history } from 'Store';

export const routeStateSelector = state =>
  state.router?.location?.state ?? history?.location?.state;
export const pathNameSelector = state =>
  state.router?.location?.pathname ?? history?.location?.pathname;
export const searchSelector = state => state.router?.location?.search ?? history?.location?.search;
export const childIndexSelector = state =>
  state.router?.location?.state?.childIndex ?? history?.location?.state?.childIndex;
export const getChildIndex = () => history?.location?.state?.childIndex;
